'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element = require('../element/Element');

var _Element2 = _interopRequireDefault(_Element);

require('./ListElement.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListElementPresentational = function ListElementPresentational(props) {
    return _react2.default.createElement(
        'div',
        { className: 'ListElement' },
        _react2.default.createElement(_Element2.default, props)
    );
};

ListElementPresentational.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired
};

exports.default = ListElementPresentational;


//////////////////
// WEBPACK FOOTER
// ./src/client/list/ListElementPresentational.js
// module id = 746
// module chunks = 0